var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"child-bg-image"},[_c('div',{staticClass:"bg-image-section"}),_c('div',{staticClass:"content-section"},[_c('app-users-page')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }